// @flow
import { createRoot } from 'react-dom/client';
import React from 'react';
import TopicSearch from './react/TopicSearch';

document.querySelectorAll('.topic-search').forEach(($search) => {
  const data = {
    url: $search.getAttribute('data-url') || '/api',
    label: $search.getAttribute('data-label') || 'Ich suche Informationen zu',
    headline: $search.getAttribute('data-headline') || '',
    langId: parseInt($search.getAttribute('data-lang'), 10) || 0,
    pId: parseInt($search.getAttribute('data-pid'), 10) || 0,
  };
  const root = createRoot($search);
  root.render(<TopicSearch {...data} />);
});
